export default "skymp5-front/90703a0d41c47367ac8ae6d6fbcc4f54.png";